import { createSelector } from '@reduxjs/toolkit';

import { type SortType } from '@/packages/api-models/common/json_query';

import { useReduxSelector } from '../../../hooks';
import { type MapBounds } from '../../mapConfiguration/slice';

import { mapControlsSelector } from './root';

export const mapControlsIsCurrentAreaSearchActiveSelector = createSelector(
  mapControlsSelector,
  state => state.isCurrentAreaSearchActive,
);

export function useMapControlsIsCurrentAreaSearchActiveSelector(): boolean {
  return useReduxSelector(mapControlsIsCurrentAreaSearchActiveSelector);
}

export const activePinSelector = createSelector(mapControlsSelector, state => state.activePin);

export const activePinIdSelector = createSelector(activePinSelector, activePin => activePin?.id);

export function useActivePinIdSelector(): string | undefined {
  return useReduxSelector(activePinIdSelector);
}

export const activePinListingIdSelector = createSelector(activePinSelector, activePin => activePin?.properties?.id);

export function useActivePinListingIdSelector(): string | undefined {
  return useReduxSelector(activePinListingIdSelector);
}

export const activePinPageSelector = createSelector(mapControlsSelector, state => state.activePinPage);

export function useActivePinPageSelector(): number | undefined {
  return useReduxSelector(activePinPageSelector);
}

export const mapSelectedBoundsSelector = createSelector(mapControlsSelector, state => state.selectedBounds);
export function useMapSelectedBoundsSelector(): MapBounds | undefined {
  return useReduxSelector(mapSelectedBoundsSelector);
}

export const activePinSortSelector = createSelector(mapControlsSelector, state => state.activePinSort);
export function useActivePinSortSelector(): SortType {
  return useReduxSelector(activePinSortSelector);
}
